import React from 'react'
import { OutlinedInput, InputLabel, FormControl, Select, MenuItem } from '@mui/material/'

export default function SelectLevel({ catId, setCatId, disabled, showAdmin }) {
    return (
        <FormControl fullWidth>
            <InputLabel id="day-label">Select Qualification*</InputLabel>
            <Select
                labelId="day-label"
                id="designation"
                value={catId}
                label="Select Level (Grade)*"
                onChange={(e) => setCatId(e.target.value)}
                required
                disabled={disabled}
            >

                <MenuItem key="1" value="1">A Level</MenuItem>
                <MenuItem key="2" value="2">AS Level</MenuItem>
                <MenuItem key="3" value="3">IGCSE</MenuItem>
                <MenuItem key="4" value="4">O Level</MenuItem>


            </Select>
        </FormControl>
    )
}
